import React from 'react';
import { CheckIcon } from 'lucide-react';
const features = ['EV & hybrid system maps', 'Battery & BMS diagnostic references', 'Motor & inverter troubleshooting', 'Charging system diagnostics', 'Thermal management references', 'Professional fault-finding workflows'];
export function SystemSection() {
  return <section className="bg-ev-black px-4 py-4 text-white" data-id="element-155" data-mp="36j0kf6vwxsxo">
      <div className="mx-auto max-w-3xl text-center" data-id="element-156" data-mp="31kgzn9t22n6w">
        <h2 className="mb-1.5 font-display text-[21px] leading-tight text-white sm:text-3xl" data-id="element-157" data-mp="31m0f4y6w0u7m">
          The Complete 6-in-1 EV &amp; Hybrid Diagnostic System
        </h2>
        <p className="mb-1 font-cond text-xl tracking-wide text-ev-green sm:text-2xl" data-id="element-158" data-mp="2stgmceda1jup">
          ⚡ EV &amp; HYBRID DIAGNOSTIC PRO™
        </p>
        <p className="mb-3 text-[12px] font-bold uppercase tracking-[0.12em] text-ev-steel sm:text-sm" data-id="element-159" data-mp="2nrhi729pqiwp">
          Understand • Identify • Test • Isolate • Diagnose • Verify
        </p>
        <ul className="grid grid-cols-1 gap-1.5 text-left sm:grid-cols-2" data-id="element-160" data-mp="2dvwkhgbog4sr">
          {features.map(feature => <li key={feature} className="flex items-start gap-2 rounded-md bg-ev-panel px-3 py-2 text-[13px] font-semibold leading-snug text-white sm:text-[15px]" data-id="element-161" data-mp="13xdczw944wmd">
              <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-ev-green" data-id="element-162" data-mp="tz7e7nils6lq" />
              {feature}
            </li>)}
        </ul>
      </div>
    </section>;
}